module.exports = __webpack_public_path__ + "media/images/number_of_visits_by_level_explained-a8aafa8d.jpg";